var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMinimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14H4V16.5C4 17.1875 4.5625 17.75 5.25 17.75C5.9375 17.75 6.5 17.1875 6.5 16.5V12.75C6.5 12.0625 5.9375 11.5 5.25 11.5H1.5C0.8125 11.5 0.25 12.0625 0.25 12.75C0.25 13.4375 0.8125 14 1.5 14ZM4 4H1.5C0.8125 4 0.25 4.5625 0.25 5.25C0.25 5.9375 0.8125 6.5 1.5 6.5H5.25C5.9375 6.5 6.5 5.9375 6.5 5.25V1.5C6.5 0.8125 5.9375 0.25 5.25 0.25C4.5625 0.25 4 0.8125 4 1.5V4ZM12.75 17.75C13.4375 17.75 14 17.1875 14 16.5V14H16.5C17.1875 14 17.75 13.4375 17.75 12.75C17.75 12.0625 17.1875 11.5 16.5 11.5H12.75C12.0625 11.5 11.5 12.0625 11.5 12.75V16.5C11.5 17.1875 12.0625 17.75 12.75 17.75ZM14 4V1.5C14 0.8125 13.4375 0.25 12.75 0.25C12.0625 0.25 11.5 0.8125 11.5 1.5V5.25C11.5 5.9375 12.0625 6.5 12.75 6.5H16.5C17.1875 6.5 17.75 5.9375 17.75 5.25C17.75 4.5625 17.1875 4 16.5 4H14Z",
    fill: "#007AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinimize);
export default __webpack_public_path__ + "static/media/icon_minimize.ff649c1273d1f1d511320fed8db531c8.svg";
export { ForwardRef as ReactComponent };